'use strict';

angular.module('footer')

.controller('FooterCtrl', function ($scope, kdAuth, kdLogin)
{
    $scope.kdAuth = kdAuth;
    $scope.kdLogin = kdLogin;
});
